import { Route } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { BookingGuard } from '@guards/booking.guard';

//TO BE COMPLETED WHEN NEEDED
export enum APP_ROUTES {
  AUTH = 'auth',
  WHITE_LABEL = 'wl',
  GROUPS_CHECKIN = 'checkin',
  BOOK = 'book',
  WHITE_LABEL_ADMIN = 'white-label-admin',
  GROUPS = 'groups',
}

export const desktopRoutes = [
  {
    path: 'auth',
    loadChildren: () => import('@pages/auth/desktop/auth.routes'),
  },
  {
    path: 'webapp',
    loadChildren: () => import('@pages/webapp/webapp.routes'),
  },
  {
    path: 'report/view/:code',
    loadComponent: () => import('@pages/report-view/report-view.component').then(m => m.ReportViewComponent),
  },
  {
    path: APP_ROUTES.GROUPS_CHECKIN,
    loadChildren: () => import('@pages/group-checkin/group-checkin.routes'),
  },
  {
    path: APP_ROUTES.WHITE_LABEL,
    loadChildren: () => import('@pages/white-label/white-label.routes'),
  },
  {
    path: 'rate-your-ride',
    loadChildren: () => import('@pages/ride-rate/ride-rate.routes'),
  },
  {
    path: 'nps',
    loadChildren: () => import('@pages/nps/nps.routes'),
  },
  {
    path: '404',
    loadComponent: () => import('@pages/404/404.component').then(m => m.Error404Component),
  },
  {
    path: '',
    loadChildren: () => import('./app/layout/desktop/logged-in-desktop-layout.routes'),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '404',
  },
] satisfies Route[];

export const mobileRoutes = [
  {
    path: 'auth',
    loadChildren: () => import('@pages/auth/mobile/auth.mobile.routes'),
  },
  {
    path: APP_ROUTES.BOOK,
    canActivate: [AuthGuard, BookingGuard],
    loadChildren: () => import('@pages/book-ride/book-ride.routes'),
  },
  {
    path: 'notifications',
    loadComponent: () => import('@pages/notifications/notifications.component').then(m => m.NotificationsPageComponent),
  },
  {
    path: 'webapp',
    loadChildren: () => import('@pages/webapp/webapp.mobile.routes'),
  },
  {
    path: APP_ROUTES.GROUPS_CHECKIN,
    loadChildren: () => import('@pages/group-checkin/group-checkin.routes'),
  },
  {
    path: APP_ROUTES.WHITE_LABEL,
    loadChildren: () => import('@pages/white-label/white-label.routes'),
  },
  {
    path: 'rate-your-ride',
    loadChildren: () => import('@pages/ride-rate/ride-rate.routes'),
  },
  {
    path: 'nps',
    loadChildren: () => import('@pages/nps/nps.routes'),
  },
  {
    path: '',
    loadChildren: () => import('./app/layout/mobile/mobile-layout.routes'),
  },
  {
    path: 'profile',
    loadChildren: () => import('@pages/profile/profile.mobile.routes'),
  },
  {
    path: APP_ROUTES.WHITE_LABEL_ADMIN,
    loadChildren: () => import('@pages/white-label-admin/white-label-admin.routes'),
  },
  {
    path: '**',
    loadComponent: () => import('@pages/404/404.component').then(m => m.Error404Component),
  },
] as Route[];
